(() => {
  function track(name, source) {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || !privacy.analyticsProcessingAllowed || !privacy.analyticsProcessingAllowed()) return;
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, {send_to: 'G-F3L7MLEYK3', kundali_source: source});
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event: name, kundali_source: source});
    }
  }
  document.addEventListener('click', event => {
    const entry = event.target.closest('[data-kundali-entry], [data-kundali-open]');
    if (entry) track('kundali_entry_click', entry.dataset.kundaliEntry || (entry.classList.contains('aathi-kundali-tab') ? 'floating_tab' : 'header'));
    const product = event.target.closest('[data-akr-root] a[href*="/products/"]');
    if (product) track('kundali_product_click', 'results');
    if (event.target.closest('.aathi-kundali-cta')) track('kundali_continue', 'popup');
  });
  let started = false;
  document.addEventListener('input', event => {
    if (!started && event.target.closest('.akr-form')) {
      started = true;
      track('kundali_form_start', 'finder');
    }
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('.akr-form')) track('kundali_submit_attempt', 'finder');
  }, true);
  document.addEventListener('akr:report', () => track('kundali_result_view', 'finder'));
  document.addEventListener('akr:cart-added', () => track('kundali_add_to_cart', 'results'));
})();
